<template lang="pug">
  section
    b-container
      h1 Rentals
      b-form-group(label="SHOW")
        b-form-checkbox-group(:options="statusOptions", text-field="text", value-field="value", v-model="filter.type", switches, @input="getRentals()")
      div
        .text-right
          b-button.btn-outline.mb-2(:to="{name: 'RentalCorporateNew'}") NEW RENTAL
        content-loader(:height="7", v-if="alert.loading")
        b-card.table-card(v-else-if="rentals && rentals.length > 0")
          p(v-if='rentals.length < 1') No rentals
          b-table(v-else="", :items="rentals", :fields="fields", sort-icon-left, sort-by="status", :sort-desc="true", responsive, borderless, hover, @row-clicked="openRow",)
            template(v-slot:cell(compName)="row") {{ row.item.company_name || row.item.customer_name }}
            template(v-slot:cell(compContractPeriod)="row") {{ `${row.item.contract_period} Month${row.item.contract_period > 1 ? 's' : ''}` }}
            template(v-slot:cell(compStatus)="row")
                b-badge(variant="light") {{ row.item.status }}
        nothing(v-else="")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import router from '@/router';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  name: 'Rental',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      rentals: [],
      currentPage: 1,
      polling: null,
      lastUpdate: '',
      fields: [
        { key: 'art_title', label: 'Piece', sortable: true },
        { key: 'compName', label: 'Customer', sortable: true },
        // { key: 'date_start_pretty', label: 'From' },
        // { key: 'compContractPeriod', label: 'Period' },
        { key: 'compStatus', label: 'Status' },
        // { key: 'date_start_pretty', label: 'To' },
        // { key: 'compRemaining', label: 'Remaining' },
        // { key: 'actions', label: '' },
      ],
      statusOptions: ['customer', 'corporate_customer'],
      filter: {
        type: ['customer', 'corporate_customer'],
      },
    };
  },
  computed: {
    totalRows() {
      return this.rentals.length;
    },
  },
  methods: {
    async getRentals() {
      this.loading();
      this.rentals = await apiService.getRentals(this.filter);
      this.clear();
    },
    openRow(row) {
      router.push({ name: 'Rental', params: { rentalId: row.id } });
    },
  },
  async created() {
    this.getRentals();
  },
};
</script>

<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/components/views/Rentals.vue